import React, { Component } from "react";

import { Container } from "reactstrap";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import InvoiceProfileBlock from "./components/InvoiceProfileBlock";
import {
  getInvoiceProfile,
  setErrorInvoiceProfile,
  updateInvoiceProfile,
  updateInvoice,
} from "../../../../store/invoices/actions";
import { isEmpty } from "lodash";
import ModifiedMetaTags from "../../../../components/ModifiedMetaTags";

class InvoicesProfile extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.getInvoiceProfile(this.props.match.params.invoiceId);
  }

  componentWillUnmount() {
    this.props.setErrorInvoiceProfile(false);
  }

  render() {
    const { invoiceData, invoiceLoader, updateInvoice, invoiceMakeLoader, permissions } =
      this.props;
    const invoiceId = this.props.match.params.invoiceId;
    const isError = this.props.isError;

    if (isError) {
      return <Redirect to={"/404"} />;
    }

    return (
      <React.Fragment>
        <div className="page-content">
        <ModifiedMetaTags title="Invoice profile | Mobihunter" />

          <Container fluid>
            {!isEmpty(invoiceData) && (
              <InvoiceProfileBlock
                updateInvoiceProfile={this.props.updateInvoiceProfile}
                history={this.props.history}
                invoiceId={invoiceId}
                invoiceData={invoiceData}
                loader={invoiceLoader}
                makeLoader={invoiceMakeLoader}
                updateInvoice={updateInvoice}
                permissions={permissions}
              />
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

InvoicesProfile.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      invoiceId: PropTypes.node,
    }).isRequired,
  }).isRequired,
  getInvoiceProfile: PropTypes.func.isRequired,
  updateInvoiceProfile: PropTypes.func.isRequired,
  setErrorInvoiceProfile: PropTypes.func.isRequired,
  updateInvoice: PropTypes.func.isRequired,
  invoiceMakeLoader: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired,
  invoiceData: PropTypes.object.isRequired,
  invoiceLoader: PropTypes.bool.isRequired,
  isError: PropTypes.any,
  permissions: PropTypes.any,
};

const mapStateToProps = state => ({
  invoiceLoader: state.InvoiceList.profileLoader,
  invoiceData: state.InvoiceList.profileData,
  invoiceMakeLoader: state.InvoiceList.profileMakeLoader,
  isError: state.InvoiceList.isError,
  permissions: state.User.permissions,
});

export default withRouter(
  connect(mapStateToProps, {
    getInvoiceProfile,
    updateInvoiceProfile,
    setErrorInvoiceProfile,
    updateInvoice,
  })(InvoicesProfile)
);
